import { Action } from '@ngrx/store'

export const INIT = '[Catalog] Init'
export const INIT_SUCCESS = '[Catalog] Init Success'
export const INIT_FAILED = '[Catalog] Init Failed'

export const APPLY = '[Catalog] Apply'

export class Init implements Action {
    readonly type = INIT
    constructor (public forceRefresh: boolean = false) {}
}
export class InitSuccess implements Action {
    readonly type = INIT_SUCCESS
}
export class InitFailed implements Action {
    readonly type = INIT_FAILED
}

export class Apply implements Action {
    readonly type = APPLY
}

export type Actions =
    Init
    | InitSuccess
    | InitFailed
    | Apply
